import store from '@/store'

const { auth } = store.state
export default {

  mustBeBuyer(to, from, next) {
    return (auth.authenticated
      && auth.token != null
      && auth.user.crole == 'buyer') ? next() : next({ name: 'home' })
  },

  mustBeSeller(to, from, next) {
    return (auth.authenticated
      && auth.token != null
      && auth.user.crole == 'seller') ? next() : next({ name: 'home' })
  },

  UserActive(to, from, next) {
    return auth.user.active ? next() : next({ name: 'home' })
  },

  InstitutionalUser(to, from, next) {
    return (auth.user.company.role == 'buyer' && !auth.user.company_name) ? next({ name: 'home' }) : next()
  },

  ClientReadOnly(to, from, next) {
    return auth.user.user_role === 'read_only_access' ?  next({name: "home"}) : next();
  },

  ClientTradeOnly(to, from, next) {
    return auth.user.user_role === 'trade_only_access' ?  next({name: "home"}) : next();
  },

  ClientDepositWithdraw(to, from, next) {
    return auth.user.user_role === 'deposit_withdraw_only_access' ?  next({name: "home"}) : next();
  },

  referralProgramActive(to, from, next) {
    return auth.user.referral_program_active == false ?  next({name: "home"}) : next();
  },
}
